// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Bv-z","tooltipWrapper":"Cv-z","icon":"Dv-z","tooltip":"Ev-z","content":"Fv-z"};